import * as actionTypes from "../actionTypes"


export const handleChange = (data) => ({
    type: actionTypes.HANDLE_CHANGE,
    payload: { data }
})